import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';
import { siteFilesQuery, SiteFilesQueryResult } from './queries/siteFilesQuery';

type SiteFilesQueryParams = { projectId: string };

type SiteFiles = SiteFilesQueryResult['getProjectSummary']['files'];

const siteFilesGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        siteFiles: builder.query<SiteFiles, SiteFilesQueryParams>({
            // A file that fails to resolve fails the whole response; keep the files that did resolve.
            queryFn: async (params, _api, _extraOptions, baseQuery) => {
                const result = await baseQuery({ body: siteFilesQuery, variables: { projectId: params.projectId } });
                if (!result.error) {
                    return { data: (result.data as SiteFilesQueryResult).getProjectSummary?.files ?? [] };
                }
                const files = (result.error as { data?: SiteFilesQueryResult }).data?.getProjectSummary?.files;
                return files ? { data: files.filter(Boolean) } : { error: result.error };
            },
            providesTags: (_result, _error, arg) => [{ type: 'project', id: arg.projectId }],
        }),
    }),
});

export const { useSiteFilesQuery } = siteFilesGraphSlice;

export default siteFilesGraphSlice;
